module.exports = __webpack_public_path__ + "img/Logo-Schwarzwald_Tani.b8012dc8.svg";